// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__2uEHd","label":"Completed_label__3Lubc"};